export enum PseudoConsolePreviewSourceTypes {
    PREVIEW_SOURCE_PRIVACY_POLICY = 'PREVIEW_SOURCE_PRIVACY_POLICY',
    PREVIEW_SOURCE_TERMS_OF_SERVICE = 'PREVIEW_SOURCE_TERMS_OF_SERVICE'
}
